<template>
<div class="right-contx pull-right box-20190523">
    <div class="top-titx font-16 bgcolor-f6f5fa">培训计划</div>
    <div class="padding-30 bgcolor-f6f5fa md-19052301x search-my200421">
        <div class="d1 clearfix">
            <input class="pull-left" type="text" id="courseName">
            <p class="pull-left search-btn" id="byCourseName_search">搜索</p>
        </div>
        <div class="d2 color-999">
            <div class="pd clearfix" style="display: flex;">
                <span class="pull-left">课程类型：</span>
                <div id="columnId" class="lamu-sp-421 clearfix color-333 pull-left clearfix">

                    <p data-coursetype="2" id="majorClass" class="">等级认定培训视频课程</p>
                </div>
            </div>
            <div class="pd clearfix" style="display: flex;">
                <span class="pull-left">专业类型：</span>
                <div id="majorChoice" class="lamu-sp-421 clearfix color-333 pull-left clearfix">
                    <p class="js-search-sortTime majorChoice active">电工</p>
                    <p class="js-search-sortTime majorChoice">电子商务师</p>
                </div>
            </div>
        </div>
    </div>
    <!--这里结束-->
    <div class="md-19052301x bgcolor-f6f5fa padding-30">
        <div class="md-hd" style="font-weight: normal;color: #666">共有&nbsp;&nbsp;<span
                style="color: #fbcb60;margin-right: 6px" id="courseCount">3</span>门&nbsp;&nbsp;课程
        </div>
        <div class="md-bd" id="class2">
            <div id="tts_class">
                <div class="md-19052302-x clearfix md20061001"><a
                        href="/el/cd?courseId=367&amp;classId=252">
                        <div class="left pull-left  no-full-time" style="position: relative;">
                            <div class="course_img" style="position: absolute;">电工五级</div>
                            <img
                                src="../../../../static/img/courseBack.jpg"
                                onerror="this.onerror=null;this.src='/img/courseBack.jpg'"
                                class="left pull-left">
                        </div>
                    </a>
                    <div class="right pull-left"><a href="###">
                            <p class="font-16 color-333 text-overflow tttittt">电工五级</p>
                        </a>
                        <div class="color-999 pppp pppp1 p2 clearfix">
                            <p class="pull-left"><i class="cusfont cusfont-luxiangji"></i>课时：<span
                                    class="color-666">53.6</span></p>
                        </div>
                        <div class="color-999 pppp p2 clearfix">
                            <p class="pull-left"><i class="cusfont cusfont-riqi"></i>购买日期：<span
                                    class="color-666">2021-03-28</span></p>
                            <p class="pull-left"><i class="cusfont cusfont-shijian1"></i>剩余时长：<span
                                    class="color-666">0天</span></p>
                        </div>
                        <div class="p5 clearfix"><span class="color-999">学习进度</span>
                            <div class="jindu200610">
                                <div style="width: 0%;"><span>0%</span></div>
                            </div>
                        </div>
                        <p class="p4"><a class="btn-0523x bg-becce1 js-gostudy2"
                                href="javascript:;">已过期</a></p>
                    </div>
                </div>
                <div class="md-19052302-x clearfix md20061001"><a
                        href="/el/cd?courseId=381&amp;classId=300">
                        <div class="left pull-left  no-full-time" style="position: relative;">
                            <div class="course_img" style="position: absolute;">助理电子商务师</div><img
                                src="/img/courseBack.jpg"
                                onerror="this.onerror=null;this.src='/img/courseBack.jpg'"
                                class="left pull-left">
                        </div>
                    </a>
                    <div class="right pull-left"><a href="###">
                            <p class="font-16 color-333 text-overflow tttittt">助理电子商务师</p>
                        </a>
                        <div class="color-999 pppp pppp1 p2 clearfix">
                            <p class="pull-left"><i class="cusfont cusfont-luxiangji"></i>课时：<span
                                    class="color-666">27.6</span></p>
                        </div>
                        <div class="color-999 pppp p2 clearfix">
                            <p class="pull-left"><i class="cusfont cusfont-riqi"></i>购买日期：<span
                                    class="color-666">2021-04-20</span></p>
                            <p class="pull-left"><i class="cusfont cusfont-shijian1"></i>剩余时长：<span
                                    class="color-666">0天</span></p>
                        </div>
                        <div class="p5 clearfix"><span class="color-999">学习进度</span>
                            <div class="jindu200610">
                                <div style="width: 100%;"><span>100%</span></div>
                            </div>
                        </div>
                        <p class="p4"><a class="btn-0523x bg-becce1 js-gostudy2"
                                href="javascript:;">已过期</a></p>
                    </div>
                </div>
                <div class="md-19052302-x clearfix md20061001"><a
                        href="/el/cd?courseId=367&amp;classId=4827">
                        <div class="left pull-left  no-full-time" style="position: relative;">
                            <div class="course_img" style="position: absolute;">电工五级</div><img
                                src="/img/courseBack.jpg"
                                onerror="this.onerror=null;this.src='/img/courseBack.jpg'"
                                class="left pull-left">
                        </div>
                    </a>
                    <div class="right pull-left"><a href="###">
                            <p class="font-16 color-333 text-overflow tttittt">电工五级</p>
                        </a>
                        <div class="color-999 pppp pppp1 p2 clearfix">
                            <p class="pull-left"><i class="cusfont cusfont-luxiangji"></i>课时：<span
                                    class="color-666">53.6</span></p>
                        </div>
                        <div class="color-999 pppp p2 clearfix">
                            <p class="pull-left"><i class="cusfont cusfont-riqi"></i>购买日期：<span
                                    class="color-666">2021-06-30</span></p>
                            <p class="pull-left"><i class="cusfont cusfont-shijian1"></i>剩余时长：<span
                                    class="color-666">13天</span></p>
                        </div>
                        <div class="p5 clearfix"><span class="color-999">学习进度</span>
                            <div class="jindu200610">
                                <div style="width: 0%;"><span>0%</span></div>
                            </div>
                        </div>
                        <p class="p4"><a class="btn-0523x bg-4b94ff js-gostudy2"
                                href="/el/info?courseId=367&amp;classId=4827"
                                target="_blank">去学习</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {

            }
        },
        created() {
            //查询直播列表
            //this.loaddictWorkTypeLiveStreamingCourse();

        },
        mounted() {

        },
        beforeDestroy() {

        },
        methods: {



        }
    }
</script>

<style scoped>

.md-19052302-x.md20061001 .right .p4 {
    position: absolute;
    right: 0;
    top: 65px;
    left: auto;
    bottom: auto;
}

.btn-0523x {
    width: 165px;
    height: 46px;
    line-height: 45px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    border-radius: 6px;
    display: inline-block;
}
.bg-4b94ff {
    background: #4b94ff;
}
.bg-becce1 {
    background: #becce1;
}

a:hover {
    color: #FF9800;
}

.md20061001 .btn-0523x {
    width: 88px;
    height: 36px;
    line-height: 36px;
}

.bg-becce1.btn-0523x {
    cursor: not-allowed;
}
.jindu200610 >div span {
    position: absolute;
    top: -18px;
    color: #666;
    width: 50px;
    right: -25px;
    text-align: center;
}
.jindu200610 >div {
    position: absolute;
    height: 100%;
    border-radius: 6px;
    background: #2b83f3;
}
.jindu200610 {
    width: 400px;
    position: relative;
    border-radius: 6px;
    height: 6px;
    background-color: #ddd;
    margin-left: 30px;
}
.md20061001 .p5 {
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
}
.md-19052302-x .right .p2 {
    line-height: 30px;
}
.md20061001 .pppp .cusfont {
    margin-right: 8px;
}
.md20061001 .pppp p {
    width: 180px;
    margin-right: 20px;
}
.md20061001 .pppp1 {
    margin-top: 15px;
}
.md-19052302-x .right .p2 {
    line-height: 30px;
}
.text-overflow {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.tttittt {
    width: 360px;
}
.md-19052302-x .right {
    position: relative;
    margin-left: 30px;
    height: 153px;
    width: 575px;
}
.md-19052302-x .left {
    position: initial;
    width: 272px;
    height: 153px;
    border-radius: 6px;
    overflow: hidden;
}
.md-19052302-x .left > img {
    display: block;
    width: 100%;
}
.course_img {
    position: absolute;
    top: 31%;
    width: 100%;
    text-align: center;
    color: white;
    font-size: 19px;
    font-weight: 400;
    letter-spacing: 8px;
    padding: 0 18px;
}
.md-19052302-x .left {
    position: initial;
    width: 272px;
    height: 153px;
    border-radius: 6px;
    overflow: hidden;
}
.md-19052302-x {
    border-bottom: 1px solid #ddd;
    padding-bottom: 25px;
    margin-bottom: 25px;
    position: relative;
}
.md-19052301x .md-hd {
    color: #4994ff;
    font-weight: bold;
    line-height: 30px;
    margin-bottom: 15px;
}
.bgcolor-f6f5fa {
    background: #f6f5fa;
}
.md-19052301x {
    margin-top: 11px;
    font-size: 14px;
    border-radius: 6px;
}
.lamu-sp-421 p {
    float: left;
}
.lamu-sp-421 p {
    margin: 0 10px;
    cursor: pointer;
    position: relative;
    user-select: none;
}
.lamu-sp-421 p.active {
    color: #3b93f6;
}
.search-my200421 .pd {
    line-height: 48px;
}
.lamu-sp-421 p {
    float: left;
}
.lamu-sp-421 p {
    margin: 0 10px;
    cursor: pointer;
    position: relative;
    user-select: none;
}

.search-my200421 .pd {
    line-height: 48px;
}
.search-my200421 .d2 {
    padding: 15px 0;
    border: 1px solid #ddd;
    margin-top: 30px;
    border-left: none;
    border-right: none;
}
.clearfix:after {
    clear: both;
    content: ".";
    display: block;
    font-size: 0;
    height: 0;
    line-height: 0;
    visibility: hidden;
}


.cusfont-search:before {
    content: "\e6e9";
}
.search-my200421 .search-btn i {
    font-size: 20px;
    vertical-align: middle;
    margin-right: 6px;
}
.search-my200421 .search-btn {
    width: 102px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    background-image: linear-gradient( to right,#63b9fd,#34dbf5);
    cursor: pointer;
}
.search-my200421 .d1 input {
    width: 690px;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    border: 1px solid #ddd;
    border-radius: 4px 0 0 4px;
}
.search-my200421 .d1 {
    padding: 0 40px;
}

.bgcolor-f6f5fa {
    background: #f6f5fa;
}
.md-19052301x {
    margin-top: 11px;
    font-size: 14px;
    border-radius: 6px;
}
.padding-30 {
    padding: 30px;
}
.bgcolor-f6f5fa {
    background: #f6f5fa;
}
.md-2018040807-xxw .top-titx {
    line-height: 60px;
    padding: 0 28px;
    border-bottom: 1px solid #ddd;
}
.pull-right {
    float: right;
}

.md-2018040807-xxw .right-contx {
    width: 940px;
    min-height: 450px;
    padding-bottom: 34px;
    border-radius: 4px;
}
.cusfont-more:before {
    content: "\e6ed";
}
.cusfont {
    font-family: "cusfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.md2018040401-menux li .iconx {
    font-size: 12px;
}
.md2018040401-menux li.active .iconx {
    display: inline-block;
}
.md2018040401-menux .md2018040401-lefttextx {
    display: inline-block;
    width: 125px;
}
.md-2018040807-xxw .md2018040401-menux .md2018040401-lefttextx {
    width: 95px;
}
.md2018040401-menux a {
    display: inline-block;
    width: 100%;
    padding: 0 10px 0 30px;
    line-height: 60px;
    border-bottom: 1px solid #f2f2f2;
}
.md2018040401-menux li a {
    border-color: #ddd;
}
.md2018040401-menux li.active a {
    background: #4d95ff;
    color: #fff;
}
.md2018040401-menux {
    width: 200px;
    border-radius: 6px;
    overflow: hidden;
}
.pull-left {
    float: left;
}
.md-2018040807-xxw .md2018040401-menux {
    background: #f6f5fa;
    width: 168px;
    border-radius: 4px;
}
.md-2018040807-xxw {
    margin-top: 16px;
}
.color-333 {
    color: #333;
}
.md-2018040806-xxw .user-namebox .user-name-xxw {
    font-size: 14px;
    font-weight: bold;
    margin-right: 6px;
}
.color-999 {
    color: #999;
}
.md-2018040806-xxw .user-namebox {
    margin-top: 36px;
}
.md-2018040806-xxw .top-navx-list > a {
    float: left;
    line-height: 32px;
    padding: 0 8px;
    margin-right: 40px;
    color: #fff;
    font-weight: bold;
    border-radius: 16px;
}

.md-2018040806-xxw .top-navx-list > a.active {
    color: #4b95ff;
    background: #fff;
}
.font-16 {
    font-size: 16px;
}
.md-2018040806-xxw .top-navx-list {
    padding-left: 15px;
}

img {
    vertical-align: middle;
    border: 0;
    -ms-interpolation-mode: bicubic;
}

.md-2018040801-lty img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

a {
    color: #333;
    text-decoration: none;
}

.md-2018040801-lty {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: 2px solid #4b95ff;
}
.md-2018040806-xxw .md-2018040801-lty {
    height: 100px;
    width: 100px;
    border: 4px solid #fff;
    position: absolute;
    top: 0;
    left: 0;
}
.md-2018040806-xxw {
    padding-left: 105px;
    padding-top: 13px;
}

.md-2018040805-xxw .user-cneter-contianer {
    margin-top: -65px;
    position: relative;
}

.top-bg-xxw01 {
    height: 276px;
    box-shadow: 0 0 20px #6478f1;
    background-color: #003262;
    /* margin-top: 50px; */
}

.container {
    clear: both;
    margin: 0 auto;
    text-align: left;
    width: 1200px;
}

.md-2018040805-xxw {
    padding: 1px 30px 20px;
    background: #fff;
    margin-top: -169px;
    margin-bottom: 40px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    min-height: 550px;
}

</style>


// WEBPACK FOOTER //
// src/components/train/personalCenter/trainingProgram.vue